import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Loading from "./Loading";
import { Picture } from "../../atoms";

const ImageWrapper = ({
  height: heightProp,
  alt,
  backgroundSize,
  backgroundColor,
  imagePosition,
  className,
  smHeight,
  size,
  useHeight,
  absoluteSize,
  data,
  url,
  endpoint,
  hasEndpoint
}) => {
  const [state, setState] = useState({
    loading: false,
    error: false,
    content: data
  });

  useEffect(() => {
    setState(prevState => {
      return { ...prevState, content: data };
    });
  }, [data])

  const getData = async () => {
    try {
      const res = await fetch(`${url}${endpoint}`);
      const content = await res.json();

      setState(prevState => {
        return { ...prevState, content, loading: false };
      });
    } catch (error) {
      setState(prevState => {
        return { ...prevState, loading: false, error: true };
      });
    }
  };

  useEffect(() => {
    if (hasEndpoint) {
      setState(prevState => {
        return { ...prevState, loading: true };
      });
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return state.loading ? (
    <Loading />
  ) : state.error ? (
    <div>No content to display</div>
  ) : (
    <Picture
      className={className}
      src={state.content.url}
      isLocal={state.content.isLocal}
      alt={alt || state.content.url}
      height={heightProp}
      backgroundSize={backgroundSize}
      backgroundColor={backgroundColor}
      imagePosition={imagePosition}
      smHeight={smHeight}
      size={size}
      useHeight={useHeight}
      absoluteSize={absoluteSize}
    />
  );
};

ImageWrapper.defaultProps = {
  alt: null,
  backgroundSize: "cover",
  backgroundColor: "#fff",
  imagePosition: "center",
  size: "lg",
  useHeight: false,
  absoluteSize: null,
  hasEndpoint: false,
  endpoint: () => null
};

ImageWrapper.propTypes = {
  data: PropTypes.object,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  smHeight: PropTypes.string,
  endpoint: PropTypes.func,
  hasEndpoint: PropTypes.bool,
  url: PropTypes.string,
  match: PropTypes.object,
  backgroundSize: PropTypes.string,
  backgroundColor: PropTypes.string,
  imagePosition: PropTypes.string,
  alt: PropTypes.string,
  size: PropTypes.oneOf(["xs", "sm", "md", "lg"]),
  useHeight: PropTypes.bool,
  absoluteSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default ImageWrapper;
